export default {
  en: {
    antd: async () => (await import('antd/es/locale/en_US')).default,
    antdV5: async () => (await import('antd-v5/locale/en_US')).default,
    locale: async () => (await import('./en_US')).default
  },
  'zh-CN': {
    antd: async () => (await import('antd/es/locale/zh_CN')).default,
    antdV5: async () => (await import('antd-v5/es/locale/zh_CN')).default,
    locale: async () => (await import('./zh_CN')).default
  },
  'zh-HK': {
    antd: async () => (await import('antd/es/locale/zh_HK')).default,
    antdV5: async () => (await import('antd-v5/es/locale/zh_HK')).default,
    locale: async () => (await import('./zh_HK')).default
  },
  // 荷兰语
  'nl-BE': {
    antd: async () => (await import('antd/es/locale/nl_BE')).default,
    antdV5: async () => (await import('antd-v5/es/locale/nl_BE')).default,
    locale: async () => (await import('./nl_BE')).default
  },
  // 法语
  'fr-BE': {
    antd: async () => (await import('antd/es/locale/fr_BE')).default,
    antdV5: async () => (await import('antd-v5/es/locale/fr_BE')).default,
    locale: async () => (await import('./fr_BE')).default
  },
  // 丹麦语
  da: {
    antd: async () => (await import('antd/es/locale/da_DK')).default,
    antdV5: async () => (await import('antd-v5/es/locale/da_DK')).default,
    locale: async () => (await import('./da_DK')).default
  },
  // 德语
  de: {
    antd: async () => (await import('antd/es/locale/de_DE')).default,
    antdV5: async () => (await import('antd-v5/es/locale/de_DE')).default,
    locale: async () => (await import('./de_DE')).default
  },
  // 阿拉伯语
  ar: {
    antd: async () => (await import('antd/es/locale/ar_EG')).default,
    antdV5: async () => (await import('antd-v5/es/locale/ar_EG')).default,
    locale: async () => (await import('./ar_EG')).default
  },
  // 法语
  fr: {
    antd: async () => (await import('antd/es/locale/fr_FR')).default,
    antdV5: async () => (await import('antd-v5/es/locale/fr_FR')).default,
    locale: async () => (await import('./fr_BE')).default
  },
  // 冰岛语
  is: {
    antd: async () => (await import('antd/es/locale/is_IS')).default,
    antdV5: async () => (await import('antd-v5/es/locale/is_IS')).default,
    locale: async () => (await import('./is_IS')).default
  },
  nl: {
    antd: async () => (await import('antd/es/locale/nl_NL')).default,
    antdV5: async () => (await import('antd-v5/es/locale/nl_NL')).default,
    locale: async () => (await import('./nl_BE')).default
  },
  // 挪威语
  no: {
    antd: async () => (await import('antd/es/locale/nb_NO')).default,
    antdV5: async () => (await import('antd-v5/es/locale/nb_NO')).default,
    locale: async () => (await import('./nb_NO')).default
  },
  // 瑞典语
  sv: {
    antd: async () => (await import('antd/es/locale/sv_SE')).default,
    antdV5: async () => (await import('antd-v5/es/locale/sv_SE')).default,
    locale: async () => (await import('./sv_SE')).default
  },
  // 泰语
  th: {
    antd: async () => (await import('antd/es/locale/th_TH')).default,
    antdV5: async () => (await import('antd-v5/es/locale/th_TH')).default,
    locale: async () => (await import('./th_TH')).default
  }
};
